import { Injectable } from '@angular/core';
import { Course, DataCourse } from '../shared/interfaces/course.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, forkJoin, map, of, retry, switchMap, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { ContentService } from './content.service';
import { LocalstorageService } from './localstorage.service';

const HOST = environment.host;
const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  filteredCourses: DataCourse[] = [];
  progress: number = 0;
  courses: DataCourse[] = [];
  courseMenu: any;
  arrayImage: any[] = [];
  categories: any[] = [];
  courses$ = new BehaviorSubject<DataCourse[]>([]);
  hasCourses$ = new BehaviorSubject<boolean>(true);

  constructor(private http:HttpClient, private contentService: ContentService, private localStorage: LocalstorageService) {

  }


  /*CURSOS ---------------------------------*/
  getCourses(): Observable<DataCourse[]> {
    const params = new HttpParams()
      .set('filter[status][value]', 1)
      .set('include', 'field_image,field_insignia,field_tax_course_category');
    return this.http.get<any>(`${API_URL}/course?sort=title`, {params})
      .pipe(
        map(resp => {
          return resp.data.map((course : any) => {
            const imageId = course.relationships.field_image.data ? course.relationships.field_image.data.id : null;
            const image = imageId ? resp.included?.find((includedItem: any) => includedItem.id === imageId) : null;
            const insigniaId = course.relationships.field_insignia.data ? course.relationships.field_insignia.data.id : null;
            const insignia = insigniaId ? resp.included?.find((includedItem: any) => includedItem.id === insigniaId) : null;
            const categoriesIds = course.relationships.field_tax_course_category.data.map((category: any) => category.id);
            const categories = categoriesIds.map((categoryId: any) => resp.included?.find((includedItem: any) => includedItem.id === categoryId));
            return {
              ...course,
              image: {filename: image.attributes.filename, url: `${HOST}${image.attributes.uri.url}`},
              insignia: {filename: insignia.attributes.filename, url: `${HOST}${insignia.attributes.uri.url}`},
              categories
            }
          })
        })
      );
  }

  filterEnrolledCourses(courses: DataCourse[], userId: number): Observable<DataCourse[]> {
    return this.isEnroll(userId).pipe(
      map(enrolledCourses => {
        const enrolledUUIDs = enrolledCourses.map((enrolled: any) => enrolled.field_course[0].target_uuid);
        return courses.filter(course => enrolledUUIDs.includes(course.id));
      })
    );
  }

  progressCourses() {
    const user = this.localStorage.getCurrentUserAsJson();
    this.courses$.subscribe(courses => {
      courses.forEach((course, i) => {
        this.contentService.getCourseProgress(course.attributes.drupal_internal__nid, user.uid).subscribe(progress => {
          course.progress = Math.round(progress.advance);
        });
      })
    })
  }

  getCoursesWithInfo(userId: number): Observable<any> {
    return this.getCourses().pipe(
      switchMap(courses => this.filterEnrolledCourses(courses, userId)),
      tap(filteredCourses => {
        this.filteredCourses = [...filteredCourses];
        this.courses$.next([...filteredCourses])
        this.hasCourses$.next(filteredCourses.length > 0)
        this.progressCourses();
      })
    );
  }

  getCompleteCourseById(id: string): Observable<any> {
    const URL = `${API_URL}/course/${id}`;
    const params = new HttpParams()
      .set('include', 'field_image,field_insignia,field_tax_course_category,field_modules,field_modules.field_lessons');
    return this.http.get<any>(URL, {params}).pipe(
      map(resp => {

      })
    )
  }

  getCourseById(id: string): Observable<DataCourse> {
  return this.getCourses()
    .pipe(
      map(courses => {
        const course = courses.find(course => course.id === id);
        if (!course) throw new Error('Curso no encontrado');
        return course;
      }),
      retry(1), catchError(this.handleError)
    );
  }

  getCategoriesOfCourse(id:any){
    const urlCategories = `https://backoffice.aprendity.com/api/taxonomy_term/course_category/${id}`;
    return this.http.get<any>(urlCategories).pipe(
      map( resp => resp.data)
    )
  }

  getAllCategories(): Observable<DataCourse[]> {
    return this.http.get<any>(`${HOST}/api/taxonomy_term/course_category`).pipe(
      map( resp => resp.data)
    )
  }

  isEnroll(uid:number): Observable<any> {
    return this.http.get<any>(`${HOST}/api/enrollment/${uid}?_format=json`)
  }

  coursesEnrolled(uid:number): Observable<any> {
    return this.http.get<any>(`${HOST}/api/enrollment/${uid}?_format=json`).pipe(
      map( resp => {
        if(resp.length === 0){
          return [];
        } else {
          return resp.map((item:any) => item.field_course[0].target_uuid);
        }
      })
    )
  }

  /*GENERALES ---------------------------------- */

  //Manejador de errores
  private handleError(error:any) {
    let errorMessage = '';
    (error.error instanceof ErrorEvent) ?  errorMessage = `Error: ${error.error.message}`
    : /* Error en el lado del servidor */ errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    // console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }

}
